export default "/_next/static/chunks/fonts/DAZN Oscine Bold-2d7b8dcbe94f6890f64474474c92aa99.ttf";